import React from 'react';
import { inject, observer } from 'mobx-react';
import { Modal } from 'antd';
import commonAppImg from '../../style/img/commonApp.png';

const store = ['appCollectStore', 'commonStore']
@inject(...store)
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'app',
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    }
  }
  onClick = () => {
    const { data } = this.props;
    window.open(`${window.server}/web#/app/appDetail/${data.sw_id}`, '_blank');
  }
  view = (e) => {
    const { data, commonStore: { view } } = this.props;
    view(data);
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  collect = (e) => {
    const { appCollectStore: { getCollectList, setMobxState, moduleType, callCollect }, data } = this.props;
    Modal.confirm({
      title: '确定取消收藏吗？',
      onOk: () => {
        callCollect({ collect: data.tms_iscoll === '1' ? '0' : '1', s_ids: data.sw_id }).then(data => {
          setMobxState({ current: 1 });
          getCollectList({ current: 1, module: moduleType });
        });
      }
    });
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  apply = (e, id) => {
    window.open(`${window.server}/web#/app?id=${this.props.location.query.id}&appId=${id}`, '_blank');
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  render() {
    const server = window.server;
    const { data, prefixCls, location: { query: { id } } } = this.props;
    const needView = id !== 'nStandard';
    return (
      <div className={`${prefixCls}`} onClick={this.onClick}>
        <div className={`${prefixCls}-img`}>
          <img onError={(e) => { e.target.onerror = null; e.target.src = commonAppImg; }} src={`${data.s_pictureNati ? server + data.s_pictureNati : commonAppImg}`} alt='' />
        </div>
        <div className={`${prefixCls}-title`} title={data.s_name}>{data.s_name}</div>
        <div className={`${prefixCls}-btns`}>
          { needView && (<div className={`${prefixCls}-btns-single`} onClick={this.view}>预览</div>) }
          <div className={`${prefixCls}-btns-single`} onClick={(e) => this.apply(e, data.sw_id)}>申请</div>
          <div className={`${prefixCls}-btns-single`} onClick={this.collect}>{data.tms_iscoll === '1' ? '收藏' : '取消收藏'}</div>
        </div>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/collect/Apps.js